import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, CheckCircle2, ShieldQuestion } from "lucide-react";

export default function AbiQuestionario() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [answers, setAnswers] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/abi/public/questionario/${token}`)
      .then(({ data }) => { setData(data); if (data.compilato) setDone(true); })
      .catch((e) => setErr(formatApiErrorDetail(e.response?.data?.detail) || "Questionario non disponibile"));
  }, [token]);

  const submit = async () => {
    setBusy(true);
    try {
      const risposte = (data.domande || []).map((d) => ({ domanda: d, risposta: answers[d] || "" }));
      await api.post(`/abi/public/questionario/${token}`, { risposte });
      setDone(true);
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const Shell = ({ children }) => (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-xl bg-violet-100 text-violet-700 flex items-center justify-center"><ShieldQuestion className="h-5 w-5" /></div>
          <div><p className="text-xs uppercase tracking-[0.2em] text-violet-500">Assietica</p><p className="font-heading font-semibold text-slate-800">Questionario assicurativo</p></div>
        </div>
        {children}
      </div>
    </div>
  );

  if (err) return <Shell><p className="text-red-600" data-testid="abi-q-error">{err}</p></Shell>;
  if (!data) return <Shell><div className="text-center text-slate-400 py-8"><Loader2 className="h-6 w-6 animate-spin inline" /></div></Shell>;

  if (done) return (
    <Shell>
      <div className="text-center py-6" data-testid="abi-q-thankyou">
        <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto mb-3" />
        <h2 className="font-heading text-xl font-semibold text-slate-800">Grazie!</h2>
        <p className="text-slate-500 mt-1">Le tue risposte sono state inviate al tuo consulente Assietica.</p>
      </div>
    </Shell>
  );

  return (
    <Shell>
      <p className="text-sm text-slate-500 mb-6">Gentile <b>{data.denominazione}</b>, per definire al meglio la sua copertura la preghiamo di rispondere a queste domande.</p>
      <div className="space-y-4" data-testid="abi-q-form">
        {(data.domande || []).map((d, i) => (
          <div key={i}>
            <label className="text-sm font-medium text-slate-700 block mb-1">{i + 1}. {d}</label>
            <Textarea rows={2} value={answers[d] || ""} onChange={(e) => setAnswers((a) => ({ ...a, [d]: e.target.value }))}
              className="resize-none" data-testid={`abi-q-input-${i}`} placeholder="La sua risposta…" />
          </div>
        ))}
      </div>
      <Button onClick={submit} disabled={busy} className="mt-6 w-full h-11 bg-violet-600 hover:bg-violet-700 text-white" data-testid="abi-q-submit">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Invia risposte"}
      </Button>
      <p className="text-[11px] text-slate-400 mt-3 text-center">I dati saranno trattati dal suo consulente assicurativo nel rispetto del GDPR.</p>
    </Shell>
  );
}
